module.exports = __webpack_public_path__ + "media/images/signatures/douglas_zuleta-1f5955064ed0a92b9482d59a5526b83daaa5aabfa5d29fe4e2b9218cddf6c2ff.jpeg";